
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#036FFD"}}),_c('path',{attrs:{"d":"M29.78 19.88l-2-2.5A1 1 0 0027 17h-6v-6a1 1 0 00-2 0v1h-6a1 1 0 00-.78.38l-2 2.5a1 1 0 000 1.24l2 2.5A1 1 0 0013 19h6v9h-2a1 1 0 000 2h6a1 1 0 000-2h-2v-4h6a1 1 0 00.78-.38l2-2.5a1 1 0 000-1.24zM19 17h-5.52l-1.2-1.5 1.2-1.5H19v3zm7.52 5H21v-3h5.52l1.2 1.5-1.2 1.5z","fill":"#fff"}})])
          )
        }
      }
    